import { render, staticRenderFns } from "./UserUpdateDialog.vue?vue&type=template&id=2660d9e4&scoped=true&"
import script from "./UserUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./UserUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660d9e4",
  null
  
)

export default component.exports